import {PROJECT_USER_ID} from "../../../constants/filters";
import queryString from "query-string";

export const GetInitFilter = () => {
    let filters = queryString.parse(document.location.search);
    return filtersNormalize( filters);
};

const filtersNormalize = filters => {
    return {
        [PROJECT_USER_ID]: filters[PROJECT_USER_ID]
    };
};
